import * as React from 'react';
import { CashoutAcceptedChangeTypeUI } from 'eTip--common';
import { CheckBox } from 'common--design-library';
import { translationForTipos } from 'easit--localization';

export interface IRateCashoutOptionsProps {
    selectedOption: CashoutAcceptedChangeTypeUI;
    selectOption: (selected: CashoutAcceptedChangeTypeUI) => void;
    isEnabledUI: boolean;
}

export const RateCashoutOptions: React.FC<IRateCashoutOptionsProps> = (props) => {
    return <div className="rate-change-options">
        <div className="rate-change-option mb-1">
            <CheckBox isChecked={props.selectedOption === CashoutAcceptedChangeTypeUI.Higher}
                onChangehandler={() => { props.isEnabledUI && props.selectOption(CashoutAcceptedChangeTypeUI.Higher); }}
                isDisabled={!props.isEnabledUI}
            >
                {translationForTipos().coupon_CashoutAcceptHigerRate}
            </CheckBox>
        </div>
        <div className="rate-change-option">
            <CheckBox isChecked={props.selectedOption === CashoutAcceptedChangeTypeUI.Any}
                onChangehandler={() => { props.isEnabledUI && props.selectOption(CashoutAcceptedChangeTypeUI.Any); }}
                isDisabled={!props.isEnabledUI}
                roleForTest="accept-rate__item--any-change"
            >
                {translationForTipos().coupon_CashoutAcceptAllRates}
            </CheckBox>
        </div>
    </div>
}